import { ButtonCreate } from "@nova/component-btn"
import classNames from "classnames"
import { CreationMenu } from "features/content-overlay/creation-menu/CreationMenu"
import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"

import { useAppSelector } from "integrations/redux/hooks"
import { useFadeOutMenu, fadeOutMenuDuration } from "./useFadeOutMenu"
import { selectActivatedFireId } from "features/map/control/selectors"

export function SidePanelCreateButton() {
    const activeProjectId = useAppSelector(selectActivatedFireId)
    const { isEditor } = useWorkspacePermissions(activeProjectId)
    const { openMenu, menuIsOpen, menuIsFading, closeMenu } = useFadeOutMenu()
    if (!isEditor) return <div />
    return (
        <>
            <ButtonCreate
                onClick={openMenu}
                className={classNames({
                    "opacity-0": menuIsOpen,
                    "transition-opacity": menuIsFading,
                    "transition-none": !menuIsFading,
                })}
                style={{
                    transitionDuration: `${fadeOutMenuDuration}ms`,
                }}
            />
            {(menuIsOpen || menuIsFading) && (
                <CreationMenu
                    shouldIncludeTools={true}
                    onMouseLeave={closeMenu}
                    onMouseEnter={openMenu}
                    onBlur={closeMenu}
                    shouldHide={menuIsFading}
                    fadeOutMs={fadeOutMenuDuration}
                />
            )}
        </>
    )
}
